import { error } from "../../utils/bimface";

export default {
  name: "section-region",
  render() {
    return null;
  },
  props: {
    boundary: Array,
    height: Array | Number,
    z: Number,
    direction: {
      type: String,
      default: "bottom",
    },
    clipDirection: {
      type: Boolean,
      default: false,
    },
  },
  inject: {
    bimface: {
      default: {
        viewer3D: null,
      },
    },
    model: {
      default: {
        model3D: null,
      },
    },
  },
  computed: {
    model3D() {
      return this.model.model3D;
    },
    viewer3D() {
      return this.model.viewer3D;
    },
  },
  data() {
    return {
      instance: null,
    };
  },
  watch: {
    "model.model3D": async function (newVal, oldVal) {
      if (newVal) {
        await this.init(this.model3D, this.viewer3D);
      }
    },
    clipDirection: function (newVal) {
      this.instance && this.instance.changeClipDirection(newVal);
    },
    boundary: function (newVal) {
      this.instance && this.instance.setBoundary(newVal);
    },
    height: function (newVal) {
      this.instance && this.instance.setHeight(newVal);
    },
    z: async function (newVal) {
      if (this.instance && this.model3D) {
        this.instance.setBoundary(
          await this.calculateBoundaryByZ(this.model3D, newVal)
        );
      }
    },
    direction: async function (newVal) {
      if (this.instance && this.model3D) {
        this.instance.setHeight(
          await this.calculateHeightByZ(this.model3D, this.z, newVal)
        );
      }
    },
  },
  async mounted() {
    if (!this.instance && this.model3D) {
      await this.init(this.model3D, this.viewer3D);
    }
  },
  methods: {
    async init(model3D, viewer3D) {
      let sectionRegionConfig =
        new Glodon.Bimface.Plugins.Section.SectionRegionConfig();
      sectionRegionConfig.viewer = viewer3D;
      if (this.height && this.boundary) {
        // 有height和boundary
        sectionRegionConfig.boundary = this.boundary;
        sectionRegionConfig.height = this.height;
      } else if (this.z) {
        // 只有z，则根据给定的z和direction做剖切
        sectionRegionConfig.boundary = await this.calculateBoundaryByZ(
          model3D,
          this.z
        );
        sectionRegionConfig.height = await this.calculateHeightByZ(
          model3D,
          this.z,
          this.direction
        );
      } else {
        error("剖切时必须提供boundary,height或z");
      }
      this.instance = new Glodon.Bimface.Plugins.Section.SectionRegion(
        sectionRegionConfig
      );
      this.instance.changeClipDirection(this.clipDirection);
    },
    async calculateBoundaryByZ(model3D, z) {
      return new Promise((resolve) => {
        model3D.getBoundingBox((data) => {
          resolve([
            {
              x: data.currentBoundingBox.max.x,
              y: data.currentBoundingBox.max.y,
              z,
            },
            {
              x: data.currentBoundingBox.max.x,
              y: data.currentBoundingBox.min.y,
              z,
            },
            {
              x: data.currentBoundingBox.min.x,
              y: data.currentBoundingBox.min.y,
              z,
            },
            {
              x: data.currentBoundingBox.min.x,
              y: data.currentBoundingBox.max.y,
              z,
            },
          ]);
        });
      });
    },
    async calculateHeightByZ(model3D, z, direction) {
      return new Promise((resolve) => {
        model3D.getBoundingBox((data) => {
          if (direction === "bottom") {
            resolve(-(z - data.currentBoundingBox.min.z));
          } else {
            resolve(data.currentBoundingBox.max.z - z);
          }
        });
      });
    },
  },
  beforeDestroy() {
    this.instance && this.instance.exit();
  },
};
